import React, { Component } from 'react'
import '../styles/OrganizationInfraUsage.css'
import APIGenericRequest from '../api/APIGenericRequest'
import OrgFooter from '../widgets/OrgFooter'
import deleteIcon from '../images/trash_green.png'
import addIcon from '../images/plus_green.png'
import deleteIconGray from '../images/trash_gray.png'
import addIconGray from '../images/plus_gray.png'
import DropdownWidget from '../widgets/DropdownWidget'
import APIOrganizationRequest from '../api/APIOrganizationRequest'
import APIClusterRequest from '../api/APIClusterRequest'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import DatePicker from '../widgets/DatePicker'

class OrganizationInfraUsage extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			dateToday: sessionStorage.getItem("date-today"),
			arboId: sessionStorage.getItem("arbo-id"),
			siteId: localStorage.getItem("siteId"),
			scrollable: false,
			aeItemObj: {},
			aeKeyTracer: 0,
			sisListItems: [],
			sisUsage: {},
			addSisUsage: {},
			deleteSisUsage: {},
			shouldDisplayValues: props.displayValues,
			isViewDetails: props.isViewDetails
		}
		this.setScrollable = this.setScrollable.bind(this)
		this.eventHandler = this.eventHandler.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.setListItem = this.setListItem.bind(this)
		this.getAllInfraSupports = this.getAllInfraSupports.bind(this)
	}

	onSubmit() {
		console.log('this.state.sisUsage', this.state.sisUsage)
		if(this.state.sisUsage) {
			let isRequired = false
			const su = Object.values(this.state.sisUsage)
			su.map((item, i) => {
				console.log(item)
				if(item.usage_date == null) {
					this.setState({
						showWarningMessage: true,
						aMessage: "Date of usage is required",
					})
					isRequired = true
					return
				}
				if(item.cluster_id == null) {
					this.setState({
						showWarningMessage: true,
						aMessage: "Cluster Name is required",
					})
					isRequired = true
					return
				}
			})
			if(isRequired) {
				return
			}
		}
		else {
			const su = Object.keys(this.state.sisUsage)
			if(su.length < 1) {
				return
			}
		}
		this.setState({showActivityIndicator: true})
		const sisUsage = []
		const addSisUsage = []
		Object.values(this.state.sisUsage).forEach((v) => {
			if(v.id != null) {
				sisUsage.push(v)
			}
			else {
				addSisUsage.push(v)
			}
		})
		const deleteSisUsage = []
		Object.values(this.state.deleteSisUsage).forEach((v) => {
			deleteSisUsage.push({id: v.id})
		})
		const data = {}
		if(this.state.sisUsageData.length == 0) {
			data["SISUsage"] = addSisUsage
		}
		else {
			data["SISUsage"] = sisUsage
		}
		if(addSisUsage.length > 0) {
			data["add"] = addSisUsage
		}
		if(deleteSisUsage.length > 0) {
			data["delete"] = deleteSisUsage
		}
		console.log('data', data)
		if(this.state.sisUsageData.length == 0) {
			const apiReq = APIOrganizationRequest.addSISUsageByOrgId(this.state.accessToken, data, this.state.arboId)
			apiReq.then((response) => {
				console.log('addSISUsageByOrgId', response)
				if(response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results.description,
						showActivityIndicator: false
					})
					return
				}
				this.setState({
					showInfoMessage: true,
					aMessage: response.status + "! " + this.state.orgName.toUpperCase() + " " + response.description,
					showActivityIndicator: false
				})
			})
		}
		else {
			const apiReq = APIOrganizationRequest.editSISUsageByOrgId(this.state.accessToken, data, this.state.arboId)
			apiReq.then((response) => {
				console.log('editSISUsageByOrgId', response)
				if(response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results.description,
						showActivityIndicator: false
					})
					return
				}
				this.setState({
					showInfoMessage: true,
					aMessage: response.status + "! " + this.state.orgName.toUpperCase() + " " + response.description,
					showActivityIndicator: false
				})
			})
		}
	}

	componentDidMount() {
		this.setState({showActivityIndicator: true})
		const obi = APIOrganizationRequest.getFarmerOrgById(this.state.accessToken, this.state.arboId)
		obi.then((response) => {
			this.setState({
				orgName: response.results.name,
				partnershipType: response.results.category,
				province: response.results.province,
				city: response.results.city,
				arcName: response.results.arc_name,
				partnershipDate: response.results.partnership_date,
			})
			const sisProv = APIOrganizationRequest.getSISProvidedByARBOId(this.state.accessToken, this.state.arboId)
			sisProv.then((response) => {
				console.log("getSISProvidedByARBOId", response)
				if(response.status === "FAILED") {
					this.setState({showActivityIndicator: false})
					return
				}
				const sisProvided = []
				for(const v of response.results) {
					sisProvided.push({
						id: v.sis_provided_id,
						name: v.name,
						sisTypeId: v.sis_type_id,
						sisTypeName: v.sis_type_name,

					})
				}
				this.setState({sisProvided: sisProvided})
				const cluster = APIClusterRequest.getAllClustersBySiteId(this.state.accessToken, this.state.siteId)
				cluster.then((response) => {
					console.log("getAllClustersBySiteId", response)
					if(response.status === "FAILED") {
						// this.setListItem()
						this.getAllInfraSupports(sisProvided)
						this.setState({showActivityIndicator: false})
						return
					}
					const cts = {}
					for(const v of response.results.rows) {
						cts[v.cluster_name] = v
					}
					const clusters = []
					const cs = Object.values(cts)
					for(const v of cs) {
						clusters.push({id: v.cluster_id, name: v.cluster_name})
					}
					this.setState({clusters: clusters})
					this.getAllInfraSupports(sisProvided, clusters)
				})
			})
		})
		window.addEventListener('resize', this.onResize.bind(this))
	}

	getAllInfraSupports(sisProvided, clusters) {
		const ais = APIOrganizationRequest.getAllInfraSupports(this.state.accessToken)
		ais.then((re) => {
			if(re.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			const sisTypes = []
			if(re.results.count > 0) {
				for(const v of re.results.rows) {
					sisTypes.push({
						id: v.sis_type_id, name: v.name
					})
				}
			}
			this.setState({sisTypes: sisTypes})
			const sisProv = APIOrganizationRequest.getSISUsageByARBOId(this.state.accessToken, this.state.arboId)
			sisProv.then((response) => {
				if(response.status === "FAILED") {
					this.setState({showActivityIndicator: false})
					return
				}
				this.setListItem(response.results, sisProvided, clusters, sisTypes)
				this.setScrollable()
			})
		})

	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.onResize.bind(this))
	}

	onResize() {
		this.setScrollable()
	}

	setListItem(sisUsage, sisProvided, clusters, sisTypes) {
		const listItems = []
		if(sisUsage != null) {
			for(const v of sisUsage) {
				const aeKey = "ae-" + this.state.aeKeyTracer
				this.state.aeItemObj[aeKey] = <ListItem data={v} sisTypes={sisTypes}
					sisProvided={sisProvided} clusters={clusters} handler={this.eventHandler}
					disabled={this.state.isViewDetails}  key={aeKey} id={aeKey} />
				this.state.aeKeyTracer++
			}
			const aeKey = "ae-" + this.state.aeKeyTracer
			this.state.aeItemObj[aeKey] = <ListItem sisProvided={sisProvided} clusters={clusters}
				sisTypes={sisTypes} handler={this.eventHandler} disabled={this.state.isViewDetails} key={aeKey} id={aeKey} />
			this.state.aeKeyTracer++
			Object.keys(this.state.aeItemObj).forEach((k => {
				listItems.push(this.state.aeItemObj[k])
			}))
		}
		else {
			const aeKey = "ae-" + this.state.aeKeyTracer
			this.state.aeItemObj[aeKey] = <ListItem disabled={this.state.isViewDetails} sisTypes={sisTypes}
					sisProvided={sisProvided} clusters={clusters} handler={this.eventHandler} key={aeKey} id={aeKey} />
			this.state.aeKeyTracer++
			listItems.push(this.state.aeItemObj[aeKey])
		}
		this.setState({
			sisListItems: listItems,
			sisTypes: sisTypes,
			sisUsageData: sisUsage,
			showActivityIndicator: false
		})
	}

	eventHandler(e, compId, key, value) {
		switch(e) {
			case "sisUsage":
				this.state.sisUsage[compId] = value
				break
			case "add":
				const added = []
				const aeKey = "ae-" + this.state.aeKeyTracer
				this.state.aeItemObj[aeKey] = <ListItem handler={this.eventHandler} sisTypes={this.state.sisTypes}
					clusters={this.state.clusters} sisProvided={this.state.sisProvided} key={aeKey} id={aeKey} />
				this.state.aeKeyTracer++
				this.state.sisListItems.push(this.state.aeItemObj[aeKey])
				Object.keys(this.state.aeItemObj).forEach((k => {
					added.push(this.state.aeItemObj[k])
				}))
				this.setState({sisListItems: added})
				break
			case "delete":
				this.state.deleteSisUsage[compId] = value
				delete this.state.aeItemObj[compId]
				const deleted = []
				Object.keys(this.state.aeItemObj).forEach((k => {
					deleted.push(this.state.aeItemObj[k])
				}))
				this.setState({sisListItems: deleted})
		}
		this.setScrollable()
	}

	setScrollable() {
		const sa = document.getElementById('oiu-scroll-area')
		const ca = document.getElementById('oiu-client-area')
		if(ca == null || sa == null) {
			return
		}
		if(sa.clientHeight < ca.clientHeight+60) {
			this.setState({scrollable: true})
		}
		else {
			this.setState({scrollable: false})
		}
	}

	render() {
		const view = <div id="org-infra-usage">
			<div id="oiu-scroll-area"><div id="oiu-client-area">
				<div id="oiu-cell1">
					<div id="oiu-cell1-r1">
						<div id="oiu-cell1-r1-i1">
							<div>Organization Name</div>
							<input type="text" value={this.state.orgName} disabled="true" />
						</div>
						<div id="oiu-cell1-r1-i2">
							<div>Type</div>
							<input type="text" value={this.state.partnershipType} disabled="true" />
						</div>
					</div>
					<div id="oiu-cell1-r2">
						<div id="oiu-cell1-r2-i1">
							<div>Province</div>
							<input type="text" value={this.state.province} disabled="true" />
						</div>
						<div id="oiu-cell1-r2-i2">
							<div>Municipality</div>
							<input type="text" value={this.state.city} disabled="true" />
						</div>
						<div id="oiu-cell1-r2-i3">
							<div>Name of Agrarian Reform Community</div>
							<input type="text" value={this.state.arcName} disabled="true" />
						</div>
					</div>
				</div>
				<div className="title-bar">SMALL INFRASTRUCTURE SUPPORT USAGE</div>
				<div id="oiu-cell2">
					<div id="infra-note">PRE-REQUISITES: CLUSTER(S) AND SIS PROVIDED
						<br/>NOTE: TO MEASURE FREQUENCY OF USAGE, NUMBER OF BENEFICIARIES, THE STATUS OF SMALL INFRASTRUCTURE SUPPORT PROVIDED TO THE ARBO
					</div>
					<table className="ae-table-header">
						<col style={{width: '15%'}} />
						<col style={{width: '25%'}} />
						<col style={{width: '20%'}} />
						<col style={{width: '20%'}} />
						<col style={{width: '20%'}} />
						<tr>
							<th>Date of Usage</th>
							<th>Cluster Name</th>
							<th>No. of Beneficiaries</th>
							<th>SIS Type</th>
							<th>SIS Provided</th>
						</tr>
					</table>
					{this.state.sisListItems}
				</div>
			</div>{this.state.scrollable === true && <OrgFooter submit={this.onSubmit}
				showSubmit={true} disabled={this.state.isViewDetails} />}</div>
			{this.state.scrollable === false && <div className="alternate-footer">
				<OrgFooter submit={this.onSubmit} disabled={this.state.isViewDetails} showSubmit={true} /></div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => { this.setState({showInfoMessage: false}) }} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class ListItem extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			ext: "EXT",
			sisUsage: {},
			cluster: "-- SELECT --",
			sisProv: "-- SELECT --",
			sisType: "-- SELECT --",
			noOfBeneficiaries: 0,
			clusters: props.clusters,
			sisProvided: props.sisProvided,
			sisTypes: props.sisTypes,
			disabled: props.disabled,
			sisDisabled: true
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
	}

	componentWillMount() {
		const ext = APIGenericRequest.getAllExtensionNames(this.state.accessToken)
		ext.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.extension_id, name: v.name})
			}
			this.setState({extName: c})
		})
	}

	componentDidMount() {
		const ext = APIGenericRequest.getAllExtensionNames(this.state.accessToken)
		ext.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.extension_id, name: v.name})
			}
			this.setState({extName: c})
		})
		if(this.props.data != null) {
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIconGray} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			const sisProvided = []
			for(const v of this.props.sisProvided) {
				if(v.sisTypeId == this.props.data.sis_type_id) {
					sisProvided.push(v)
				}
			}
			let sisDisabled = false
			if(this.state.disabled != null) {
				sisDisabled = this.state.disabled
			}
			this.state.sisUsage["id"] = this.props.data.id
			this.setState({
				clusters: this.props.clusters,
				sisProvided: sisProvided,
				usageDate: this.props.data.usage_date,
				cluster: this.props.data.cluster_name,
				sisProv: this.props.data.sis_provided_name,
				sisType: this.props.data.sis_type_name,
				noOfBeneficiaries: this.props.data.no_of_beneficiaries,
				addDeleteButton: addDeleteButton,
				sisDisabled: sisDisabled
			})
			return
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIconGray} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.sisUsage)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		// this.props.handler("delete", this.state.itemId, null, this.state.sisUsage)
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove small infrastructure support usage ${this.state.sisType}?`
		})
	}

	render() {
		const view = <div className="oiu-listitem">
			<div>{this.state.addDeleteButton}</div>
			<table className="ae-table-data">
				<col style={{width: '15%'}} />
				<col style={{width: '25%'}} />
				<col style={{width: '20%'}} />
				<col style={{width: '20%'}} />
				<col style={{width: '20%'}} />
				<tr>
					<td>
						<DatePicker className="oiu-date" value={this.state.usageDate} onChange={(value) =>{
							this.state.sisUsage["usage_date"] = value
							this.props.handler("sisUsage", this.state.itemId, null, this.state.sisUsage)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({usageDate: value})
						}} disabled={this.state.disabled} />
					</td>
					<td>
						<DropdownWidget list={this.state.clusters} placeholder={this.state.cluster} cStyle={{"width": "100%"}}
							onItemSelected={(id, val) => {
								this.state.sisUsage["cluster_id"] = id
								this.props.handler("sisUsage", this.state.itemId, null, this.state.sisUsage)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
							}} disabled={this.state.disabled} />
					</td>
					<td><input className="oiu-position" type="text" value={this.state.noOfBeneficiaries} onChange={(e) =>{
							const checker = /^[0-9]+$/;
							const isValid = checker.test(e.target.value);
							if(isValid) {
								this.state.sisUsage["no_of_beneficiaries"] = e.target.value
								this.props.handler("sisUsage", this.state.itemId, null, this.state.sisUsage)
								this.setState({noOfBeneficiaries: e.target.value})
							}
							else {
								if(isNaN(parseInt(e.target.value))) {
									this.setState({contactNo: null})
									e.target.value = "";
								}
								else {
									e.target.value = parseInt(e.target.value);
								}
							}
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
						}} disabled={this.state.disabled} /></td>
					<td>
						<DropdownWidget list={this.state.sisTypes} placeholder={this.state.sisType} cStyle={{"width": "100%"}}
							onItemSelected={(id, val) => {
								const sisProvided = []
								if(this.props.sisProvided) {
									for(const v of this.props.sisProvided) {
										if(v.sisTypeId == id) {
											sisProvided.push(v)
										}
									}
								}
								this.setState({sisProvided: sisProvided, sisProv: "-- SELECT --", sisDisabled: false})
								this.state.sisUsage["sis_type_id"] = id
								this.state.sisUsage["sis_provided_id"] = null
								this.props.handler("sisUsage", this.state.itemId, null, this.state.sisUsage)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
							}} disabled={this.state.disabled} />
					</td>
					<td>
						<DropdownWidget list={this.state.sisProvided} placeholder={this.state.sisProv} cStyle={{"width": "100%"}}
							onItemSelected={(id, val) => {
								this.state.sisUsage["sis_provided_id"] = id
								this.props.handler("sisUsage", this.state.itemId, null, this.state.sisUsage)
								if(this.state.addDeleteButton.props.alt == "ADD") {
									this.onAddItemClick()
								}
							}} disabled={this.state.sisDisabled} />
					</td>
				</tr>
			</table>
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
				onClick={(e) => {
					this.setState({showConfirmMessage: false})
					if(e.target.innerHTML === "NO") {
					}
					else {
						this.props.handler("delete", this.state.itemId, null, this.state.sisUsage)
					}
			}} />}
		</div>
		return(view)
	}
}

export default OrganizationInfraUsage
